import { useEffect, useState } from "react";
import LOGO from "@/assets/logo.png";

const TEL = "+36303915392";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItems = [
    { label: "01 — Bemutatkozás", href: "#about" },
    { label: "02 — Kezelések", href: "#treatments" },
    { label: "03 — Vélemények", href: "#testimonials" },
    { label: "04 — Kapcsolat", href: "#contact" },
  ];

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
        scrolled
          ? "bg-anthracite-950/85 backdrop-blur-2xl border-b border-gold-500/10 py-3"
          : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-14 flex items-center justify-between">
        <a href="#top" data-testid="navbar-logo" className="flex items-center gap-4 group">
          <img
            src={LOGO}
            alt="NOBLESSE"
            className={`transition-all duration-500 ${scrolled ? "h-10" : "h-14 md:h-16"} w-auto`}
          />
          <span className="hidden sm:inline font-serif text-xl md:text-2xl tracking-[0.4em] text-cream font-light">
            NOBLESSE
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.href.replace("#", "")}`}
              className="text-[10px] uppercase tracking-[0.3em] text-cream/60 hover:text-gold-500 transition-colors duration-300 font-light"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${TEL}`}
            data-testid="navbar-cta-call"
            className="hidden sm:inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-anthracite-950 bg-gold-500 hover:bg-gold-400 px-5 py-3 transition-all duration-300 font-medium"
          >
            Időpont
          </a>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menü"
            data-testid="navbar-mobile-toggle"
            className="lg:hidden flex flex-col gap-1.5 p-2"
          >
            <span className={`block w-6 h-px bg-cream transition-all ${mobileOpen ? "rotate-45 translate-y-2" : ""}`} />
            <span className={`block w-6 h-px bg-cream transition-all ${mobileOpen ? "opacity-0" : ""}`} />
            <span className={`block w-6 h-px bg-cream transition-all ${mobileOpen ? "-rotate-45 -translate-y-2" : ""}`} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          mobileOpen ? "max-h-96 mt-6" : "max-h-0"
        }`}
      >
        <div className="px-6 pb-6 bg-anthracite-950/95 backdrop-blur-xl border-t border-gold-500/10">
          <nav className="flex flex-col gap-5 pt-6">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="text-xs uppercase tracking-[0.3em] text-cream/70 hover:text-gold-500 py-2 border-b border-white/5"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
